<!-- Messages toggle -->
<button mat-icon-button (click)="openPanel()" #messagesOrigin>
    @if (unreadCount > 0) {
        <span
            class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center"
        >
            <span
                class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-gray-900 px-1 text-xs font-medium text-indigo-50"
            >
                {{ unreadCount }}
            </span>
        </span>
    }
    <mat-icon>domain</mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>
    <div
        class="fixed inset-0 flex flex-col overflow-hidden shadow-lg sm:static sm:inset-auto sm:w-90 sm:min-w-90 sm:rounded-2xl"
    >
        <!-- Header -->
        <div
            class="flex shrink-0 items-center bg-gray-800 py-4 pl-6 pr-4 text-on-primary"
        >
            <div class="-ml-1 mr-3 sm:hidden">
                <button mat-icon-button (click)="closePanel()">
                    <mat-icon
                        class="text-current icon-size-5"
                        [svgIcon]="'heroicons_solid:x-mark'"
                    ></mat-icon>
                </button>
            </div>
            <div class="text-lg font-medium leading-10">Switch Branch</div>
        </div>

        <!-- Content -->
        <div
            class="bg-card relative flex flex-auto flex-col divide-y overflow-y-auto sm:max-h-120"
        >
            <!-- Messages -->
            @for (message of messages; track trackByFn($index, message)) {
                <div
                    class="group flex p-5 hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5"
                >
                    <!-- Message with a link -->
                    @if (message.branch) {
                        <!-- Normal links -->
                        @if (message.branch) {
                            <div
                                class="flex flex-auto flex-col"
                                (click)="switchBranch(message)"
                            >
                                @if (message.branch) {
                                    <div
                                        class="line-clamp-1 font-semibold"
                                        [innerHTML]="message.branch.branchName"
                                    ></div>
                                }
                            </div>
                        }
                    }
                </div>

                <!-- Message content template -->
                <ng-template #messageContent>
                    <!-- Title, description & time -->
                    <div class="flex flex-auto flex-col">
                        @if (message.branch) {
                            <div
                                class="line-clamp-1 font-semibold"
                                [innerHTML]="message.branch.branchName"
                            ></div>
                        }
                        @if (message.branch) {
                            <div
                                class="line-clamp-2"
                                [innerHTML]="message.branch.branchId"
                            ></div>
                        }
                        <div class="text-secondary mt-2 text-sm leading-none">
                            {{
                                message.branch.createdAt
                                    | date: 'MMM dd, h:mm a'
                            }}
                        </div>
                    </div>
                </ng-template>
            }

            <!-- No messages -->
            <div
                *ngIf="!messages || !messages.length"
                class="flex flex-auto flex-col items-center justify-center px-8 py-12 sm:justify-start"
            >
                <div
                    class="flex h-14 w-14 flex-0 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-600"
                >
                    <mat-icon class="text-primary-700 dark:text-primary-50"
                        >domain</mat-icon
                    >
                </div>
                <div class="mt-5 text-2xl font-semibold tracking-tight">
                    No Branch configured yet
                </div>
                <div
                    class="text-secondary mt-1 w-full max-w-60 text-center text-md"
                >
                    When you belong to a branch, they will appear here.
                </div>
            </div>
        </div>
    </div>
</ng-template>
